import React, { useEffect } from 'react';
import { TopBar, WhatsAppButton, PurchaseNotifications } from '../components/Layout';
import { trackFb } from '../lib/fbpixel';
import { Hero, ArchiveContents, Tension, WhatThisIs, MainCollection } from '../components/Sections';
import { Volumes, Bonuses, Benefits, PostPurchase } from '../components/ContentSections';
import { Authority, Pricing, Guarantee, FAQ, FinalCTA } from '../components/ConversionSections';
export function LandingPage() {
  useEffect(() => {
    // Fire ViewContent when the sales page loads
    trackFb('ViewContent', {
      content_name: 'Colección NOS MIENTEN',
      content_type: 'product',
      currency: 'ARS',
      value: 27990
    });
  }, []);
  return <div className="min-h-screen bg-brand-dark flex flex-col font-sans selection:bg-brand-gold selection:text-brand-dark" data-id="element-237">
      <TopBar data-id="element-238" />

      <main className="flex-1" data-id="element-239">
        <Hero data-id="element-240" />
        <Tension data-id="element-241" />
        <ArchiveContents data-id="element-242" />
        <WhatThisIs data-id="element-243" />
        <MainCollection data-id="element-244" />
        <Volumes data-id="element-245" />
        <Bonuses data-id="element-246" />
        <Benefits data-id="element-247" />
        <PostPurchase data-id="element-248" />
        <Authority data-id="element-249" />
        <Pricing data-id="element-250" />
        <Guarantee data-id="element-251" />
        <FAQ data-id="element-252" />
        <FinalCTA data-id="element-253" />
      </main>

      <footer className="bg-brand-anthracite py-8 border-t border-brand-card text-center px-5" data-id="element-254">
        <p className="text-brand-muted text-xs" data-id="element-255">
          &copy; {new Date().getFullYear()} Colección Nos Mienten. Todos los
          derechos reservados.
        </p>
      </footer>

      <WhatsAppButton data-id="element-256" />
      <PurchaseNotifications data-id="element-257" />
    </div>;
}